/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

import { createApp, h } from "vue";
import App from "./App.vue";
import router from "./router";

import { Vue3BsPaginate } from "vue3-bootstrap-paginate";

import IdleVue from "idle-vue";
import emitter from "tiny-emitter/instance";

import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from "bootstrap";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import nlhpc from "./plugins/nlhpc";
import CubeLoader from "./components/CubeLoader.vue";
import SpinnerLoader from "./components/SpinnerLoader.vue";
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

const app = createApp({ render: () => h(App) });

app.component("Vue3BsPaginate", Vue3BsPaginate);
app.component("CubeLoader", CubeLoader);
app.component("SpinnerLoader", SpinnerLoader);
app.component('QuillEditor', QuillEditor)

app.use(router);
app.use(nlhpc);
app.use(VueSweetalert2, {
  buttonsStyling: false,
  customClass: {
    confirmButton: "btn btn-primary",
    cancelButton: "btn btn-link",
  },
});

let user = JSON.parse(localStorage.getItem("user") || null);

app.directive("tooltip", {
  mounted(el, binding) {
    // Tooltip de Bootstrap
    // Asegúrate de que 'bootstrap' esté disponible aquí
    el._tooltipInstance = new bootstrap.Tooltip(el, binding.value || {});
  },
  updated(el, binding) {
    if (el._tooltipInstance) {
      el._tooltipInstance.dispose();
    }
    el._tooltipInstance = new bootstrap.Tooltip(el, binding.value || {});
  },
  unmounted(el) {
    // Eliminar tooltip al destruir el elemento
    if (el._tooltipInstance) {
      el._tooltipInstance.dispose();
      el._tooltipInstance = null;
    }
  },
});

app.mount("#app");
